import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const HierarchyIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };

  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.25 20C9.25 18.48 10.48 17.25 12 17.25C13.52 17.25 14.75 18.48 14.75 20C14.75 21.52 13.52 22.75 12 22.75C10.48 22.75 9.25 21.52 9.25 20ZM13.25 20C13.25 19.31 12.69 18.75 12 18.75C11.31 18.75 10.75 19.31 10.75 20C10.75 20.69 11.31 21.25 12 21.25C12.69 21.25 13.25 20.69 13.25 20Z"
        fill="currentColor"
      />
      <path
        d="M17.25 20C17.25 18.48 18.48 17.25 20 17.25C21.52 17.25 22.75 18.48 22.75 20C22.75 21.52 21.52 22.75 20 22.75C18.48 22.75 17.25 21.52 17.25 20ZM21.25 20C21.25 19.31 20.69 18.75 20 18.75C19.31 18.75 18.75 19.31 18.75 20C18.75 20.69 19.31 21.25 20 21.25C20.69 21.25 21.25 20.69 21.25 20Z"
        fill="currentColor"
      />
      <path
        d="M1.25 20C1.25 18.48 2.48 17.25 4 17.25C5.52 17.25 6.75 18.48 6.75 20C6.75 21.52 5.52 22.75 4 22.75C2.48 22.75 1.25 21.52 1.25 20ZM5.25 20C5.25 19.31 4.69 18.75 4 18.75C3.31 18.75 2.75 19.31 2.75 20C2.75 20.69 3.31 21.25 4 21.25C4.69 21.25 5.25 20.69 5.25 20Z"
        fill="currentColor"
      />
      <path
        d="M12 6.50001C16.0135 6.50001 7.82952 6.50001 12 6.50001V6.50001Z"
        fill="currentColor"
      />
      <path
        d="M11.25 18L11.25 7.25001C11.25 6.84001 11.59 6.50001 12 6.50001C12.41 6.50001 12.75 6.84001 12.75 7.25001L12.75 18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18Z"
        fill="currentColor"
      />
      <path
        d="M3.25 18L3.25 14C3.25 11.58 4.58 10.25 7 10.25L17 10.25C19.42 10.25 20.75 11.58 20.75 14L20.75 18C20.75 18.41 20.41 18.75 20 18.75C19.59 18.75 19.25 18.41 19.25 18L19.25 14C19.25 12.42 18.58 11.75 17 11.75L7 11.75C5.42 11.75 4.75 12.42 4.75 14L4.75 18C4.75 18.41 4.41 18.75 4 18.75C3.59 18.75 3.25 18.41 3.25 18Z"
        fill="currentColor"
      />
      <path
        d="M13.75 8.00001L10.5 8.00001C8.97998 8.00001 7.74998 6.77001 7.74998 5.25001L7.74998 3.25001C7.74998 1.73001 8.97998 0.500008 10.5 0.500008L13.75 0.500008C15.27 0.500008 16.5 1.73001 16.5 3.25001L16.5 5.25001C16.5 6.77001 15.27 8.00001 13.75 8.00001ZM10.5 2.00001C9.80998 2.00001 9.24998 2.56001 9.24998 3.25001L9.24998 5.25001C9.24998 5.94001 9.80998 6.50001 10.5 6.50001L13.75 6.50001C14.44 6.50001 15 5.94001 15 5.25001L15 3.25001C15 2.56001 14.44 2.00001 13.75 2.00001L10.5 2.00001Z"
        fill="currentColor"
      />
    </svg>
  );
};
const HierarchyIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={HierarchyIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default HierarchyIcon;
